"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRouterDom = require("react-router-dom");
var _config = require("../config");
var _EditStoreForm = _interopRequireDefault(require("./EditStoreForm"));
var _StoreActions = require("./StoreActions");
var _excluded = ["setSubmitting"],
  _excluded2 = ["logo", "background"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CategoryOfStoreField = null;
try {
  CategoryOfStoreField = require('react-platform-category-of-store/dist/CategoryOfStore/CategoryOfStoreField').default;
} catch (error) {
  console.log('errror categori of store');
}
var SpecificitiesOfStoreFields = null;
try {
  SpecificitiesOfStoreFields = require('react-platform-specificity-of-store/dist/SpecificityOfStoreWithSections/SpecificitiesOfStoreFields').SpecificitiesOfStoreFields;
} catch (error) {
  console.log('cannot find SpecificitiesOfStoreFields');
}
var setSpecificitiesValuesToFormData = null;
try {
  setSpecificitiesValuesToFormData = require('react-platform-specificity-of-store/dist/SpecificityOfStoreWithSections/SpecificitiesOfStoreFields').setSpecificitiesValuesToFormData;
} catch (error) {
  console.log('cannot find setSpecificitiesValuesToFormData');
}
var styles = function styles(theme) {
  var _header, _formFields;
  return {
    header: (_header = {
      backgroundColor: "#0a76a9",
      backgroundImage: "url(\"".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png\")"),
      backgroundSize: 'cover',
      color: '#fff',
      display: 'flex',
      height: '25vh',
      minHeight: '25vh'
    }, _defineProperty(_header, theme.breakpoints.down('sm'), {
      height: '55vh'
    }), _defineProperty(_header, theme.breakpoints.up('md'), {
      height: '25vh'
    }), _header),
    formFields: (_formFields = {
      paddingBottom: '4rem',
      paddingRight: '1rem',
      paddingLeft: '1rem',
      width: '100%'
    }, _defineProperty(_formFields, theme.breakpoints.down('sm'), {
      paddingTop: 36
    }), _defineProperty(_formFields, theme.breakpoints.up('md'), {
      paddingTop: 92
    }), _formFields)
  };
};
var EditStore = /*#__PURE__*/function (_React$Component) {
  _inherits(EditStore, _React$Component);
  var _super = _createSuper(EditStore);
  function EditStore() {
    var _this;
    _classCallCheck(this, EditStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (values, _ref) {
      var setSubmitting = _ref.setSubmitting,
        props = _objectWithoutProperties(_ref, _excluded);
      var logo = values.logo,
        background = values.background,
        data = _objectWithoutProperties(values, _excluded2);
      var formData = new FormData();
      var excludedFields = ['address-state', 'background_image_data', 'logo_image_data'];
      if (SpecificitiesOfStoreFields) {
        // specificities to be added
        setSpecificitiesValuesToFormData(formData, 'store_specificities', data, _this.props.store);
      }
      _lodash.default.forOwn(data, function (value, key) {
        if (excludedFields.indexOf(key) !== -1) {
          return;
        } else if (value) {
          formData.append(key, value);
        }
      });
      if (logo && logo instanceof File) formData.append('logo', logo);
      if (background && background instanceof File) formData.append('background', background);
      _this.props.dispatch({
        type: _StoreActions.UPDATE_STORE,
        model: formData,
        history: _this.props.history
      });
    });
    return _this;
  }
  _createClass(EditStore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.title = this.props.intl.formatMessage({
        id: "Edit store page title",
        defaultMessage: "Edit store page title"
      });
      this.props.dispatch({
        type: _StoreActions.FETCH_STORE,
        history: this.props.history
      });
      if (CategoryOfStoreField) {
        this.props.dispatch({
          type: 'FETCH_CATEGORIES_OF_STORE'
        });
      }
      if (SpecificitiesOfStoreFields) {
        this.props.dispatch({
          type: 'FETCH_SPECIFICITIES_OF_STORE'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, !_lodash.default.isEmpty(this.props.store) && /*#__PURE__*/_react.default.createElement(_EditStoreForm.default, _extends({
        handleSubmit: this.handleSubmit
      }, this.props)));
    }
  }]);
  return EditStore;
}(_react.default.Component);
var _default = (0, _styles.withStyles)(styles)((0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    store: state.storeReducer.store,
    updateInProgress: state.storeReducer.updateInProgress,
    isStoreFetchingInProgress: state.storeReducer.fetchInProgress,
    specificities: state.specificityOfStoreReducer ? state.specificityOfStoreReducer.specificities : null,
    categories: state.categoryOfStoreReducer ? state.categoryOfStoreReducer.categories : null
  };
})((0, _Translations.injectIntl)(EditStore))));
exports.default = _default;